import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/root-reducer";

const ZohoSalesIQ = () => {
  const { chatbot_enabled: chatbotEnabled } = useSelector(
    (state: RootState) => state.user.selectedOrg
  );
  useEffect(() => {
    if (chatbotEnabled) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "zsiqscript";
      script.defer = true;
      script.src =
        "https://salesiq.zohopublic.com/widget?wc=siq1e42ff80a8f6fd5cb230db0e9236b54d0cbe97f92c2f184873b8acf86273cf86";

      (window as any).$zoho = (window as any).$zoho || {};
      (window as any).$zoho.salesiq = (window as any).$zoho.salesiq || {
        ready: function () {},
      };

      const existingScript = document.getElementById("zsiqscript");
      if (!existingScript) {
        document.body.appendChild(script);
      }

      return () => {
        const existingScript = document.getElementById("zsiqscript");
        if (existingScript) {
          document.body.removeChild(existingScript);
        }
        // Cleanup Zoho elements if necessary
        const zohoContainer = document.querySelector(".zsiq_floatmain");
        if (zohoContainer) {
          zohoContainer.remove();
        }
      };
    }
  }, [chatbotEnabled]);

  return null;
};

export default ZohoSalesIQ;
